import {
  UPDATE_ACCOUNT
} from '../../actions/account'

const initialState: State = {
  selectedAccount: 'all',
  hasWriteAccess: false,
}

export default function accountsReducer(state = initialState, action): State {
  switch (action.type) {
    case UPDATE_ACCOUNT: {
      const { account= {} } = action.payload;
      return {
        ...state,
        selectedAccount: account.pKey_TPM_Account_GUID || 'all',
        hasWriteAccess: account.hasWriteAccess,
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/account/index.js